export { default } from './global-footer';
